export default {


    computed: {
        //业务类型
        getBusinessType() {
            return [{
                label: "中转费用",
                value: 1
            }, {
                label: "一般入库",
                value: 2
            }, {
                label: "销售订单",
                value: 3
            }, {
                label: "仓储",
                value: 4
            }, {
                label: "其他",
                value: 5
            }, {
                label: "调拨",
                value: 6
            }, {
                label: "退货",
                value: 7
            }, {
                label: "All",
                value: 10
            },{
                label: "无来源入库",
                value: 11
            }]
        },
        //事务项
        getTransaction() {
            return [{
                label: "已创建",
                value: "已创建"
            }, {
                label: "已确认",
                value: "已确认"
            }, {
                label: "已结算",
                value: "已结算"
            },]
        },
        //事务项
        getPayStatus() {
            return [{
                label: "已创建",
                value: "已创建"
            }, {
                label: "已确认",
                value: "已确认"
            }, {
                label: "已结算",
                value: "已结算"
            },]
        },
    },
}
